export default {
  setAuthorized(state, status) {
    state.isLoggedIn = status;
  },

  setAvailableUncompletedResume(state, status) {
    state.isAvailableUncompletedResume = status;
  },
};
